import * as Sentry from '@sentry/react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  getEnvVariablesForDevices,
  type DeviceEnvVariablesForDevice,
  type GetEnvVariablesForDevicesResponse,
} from 'api/admin/washboard/washboard';

type UseDeviceEnvVariablesResult = {
  devices: DeviceEnvVariablesForDevice[];
};

const errorHandler = (error: unknown) => {
  Sentry.captureException(error);
};

export const useDeviceEnvVariables = (
  deviceIds: number[],
  enabled = true,
): UseQueryResult<UseDeviceEnvVariablesResult, unknown> => {
  return useQuery({
    queryKey: ['deviceEnvVariables', deviceIds],
    queryFn: async () => {
      const { data } = (await getEnvVariablesForDevices({
        deviceIds,
      })) as AxiosResponse<GetEnvVariablesForDevicesResponse>;

      return {
        devices: data.devices,
      };
    },
    onError: errorHandler,
    enabled: enabled && deviceIds.length > 0,
    retry: 1,
  });
};
